import React from 'react';
import { AddImage } from './vector-groups/_add-image';
import { AddPerson } from './vector-groups/_add-person';
import { AiWand } from './vector-groups/_ai-wand';
import { AlertCircle } from './vector-groups/_alert-circle';
import { AlertCircleHelp } from './vector-groups/_alert-circle-help';
import { AlertCircleInfo } from './vector-groups/_alert-circle-info';
import { AlertTriangle } from './vector-groups/_alert-triangle';
import { ArrowsMove } from './vector-groups/_arrows-move';
import { Bin } from './vector-groups/_bin';
import { Border } from './vector-groups/_border';
import { Facebook } from './vector-groups/_brand-facebook';
import { Instagram } from './vector-groups/_brand-instagram';
import { Brush } from './vector-groups/_brush';
import { CheckCircle } from './vector-groups/_check-circle';
import { Checkmark } from './vector-groups/_checkmark';
import { ChevronDown } from './vector-groups/_chevron-down';
import { ChevronLeft } from './vector-groups/_chevron-left';
import { ChevronRight } from './vector-groups/_chevron-right';
import { ChevronUp } from './vector-groups/_chevron-up';
import { ChevronsRight } from './vector-groups/_chevrons-right';
import { Close } from './vector-groups/_close';
import { Cog } from './vector-groups/_cog';
import { Computer } from './vector-groups/_computer';
import { Confetti } from './vector-groups/_confetti';
import { Crop } from './vector-groups/_crop';
import { Cube3d } from './vector-groups/_cube-3d';
import { Cube3dFilled } from './vector-groups/_cube-3d-filled';
import { CursorText } from './vector-groups/_cursor-text';
import { Devices } from './vector-groups/_devices';
import { DragDrop } from './vector-groups/_drag-drop';
import { EllipsisVertical } from './vector-groups/_ellipsis-vertical';
import { Eraser } from './vector-groups/_eraser';
import { Eye } from './vector-groups/_eye';
import { FilePdf } from './vector-groups/_file-pdf';
import { FileUpload } from './vector-groups/_file-upload';
import { Filter } from './vector-groups/_filter';
import { FontFamily } from './vector-groups/_font-style';
import { FontStyleBold } from './vector-groups/_font-style-bold';
import { FontStyleItalic } from './vector-groups/_font-style-italic';
import { Hand } from './vector-groups/_hand';
import { Maximize } from './vector-groups/_maximize';
import { Minimize } from './vector-groups/_minimize';
import { Minus } from './vector-groups/_minus';
import { NoBorder } from './vector-groups/_no-border';
import { Engraving } from './vector-groups/_option-engraving';
import { Image } from './vector-groups/_option-image';
import { Pencil } from './vector-groups/_pencil';
import { Phone } from './vector-groups/_phone';
import { PinchToZoom } from './vector-groups/_pinch-to-zoom';
import { Plus } from './vector-groups/_plus';
import { PlusCircle } from './vector-groups/_plus-circle';
import { Replace } from './vector-groups/_replace';
import { Rotate3d } from './vector-groups/_rotate-3d';
import { RotateImage } from './vector-groups/_rotate-image';
import { Ruler } from './vector-groups/_ruler';
import { ScrollToZoom } from './vector-groups/_scroll-to-zoom';
import { ShoppingCart } from './vector-groups/_shopping-cart';
import { Sparkles } from './vector-groups/_sparkles';
import { ThreeDimensional } from './vector-groups/_three-dimensional';
import { ZoomIn } from './vector-groups/_zoom-in';
import { ZoomOut } from './vector-groups/_zoom-out';

export type IconNames = keyof typeof Icons;
export const Icons = {
    'general-ui-chevron-up': <ChevronUp />,
    'general-ui-chevron-right': <ChevronRight />,
    'general-ui-chevron-down': <ChevronDown />,
    'general-ui-chevron-left': <ChevronLeft />,

    'general-ui-chevrons-right': <ChevronsRight />,

    'general-ui-minus': <Minus />,
    'general-ui-plus': <Plus />,
    'general-ui-maximize': <Maximize />,
    'general-ui-minimize': <Minimize />,
    'general-ui-zoom-in': <ZoomIn />,
    'general-ui-zoom-out': <ZoomOut />,
    'general-ui-arrows-move': <ArrowsMove />,

    'general-ui-checkmark': <Checkmark />,
    'general-ui-cog': <Cog />,
    'general-ui-eraser': <Eraser />,
    'general-ui-pencil': <Pencil/>,
    'general-ui-confetti': <Confetti />,
    'general-ui-filter': <Filter />,
    'general-ui-close': <Close />,
    'general-ui-bin': <Bin />,
    'general-ui-crop': <Crop />,
    'general-ui-replace': <Replace />,
    'general-ui-brush': <Brush />,
    'general-ui-ellipsis-v': <EllipsisVertical />,
    'general-ui-ruler': <Ruler />,
    'general-ui-rotate-image': <RotateImage />,
    'general-ui-devices': <Devices />,
    'general-ui-eye': <Eye />,

    'alert-circle-info': <AlertCircleInfo />,
    'alert-circle-help': <AlertCircleHelp />,
    'alert-circle-exclamation': <AlertCircle />,
    'alert-triangle-exclamation': <AlertTriangle />,
    'alert-circle-check': <CheckCircle />,
    'alert-circle-plus': <PlusCircle />,

    'upload-from-facebook': <Facebook />,
    'upload-from-instagram': <Instagram />,
    'upload-from-computer': <Computer />,
    'upload-from-file': <FilePdf />,

    'image-file-upload': <FileUpload />,
    'image-file-check': <CheckCircle />,
    'image-file-add': <AddImage />,

    'option-image': <Image />,
    'option-engraving': <Engraving />,

    'font-family': <FontFamily />,
    'bold': <FontStyleBold />,
    'italic': <FontStyleItalic />,
    'text-bar': <CursorText />,

    "ai-wand" : <AiWand />,

    'three-dimensional': <ThreeDimensional />,

    'shopping-cart': <ShoppingCart />,
    'sparkles': <Sparkles />,

    'controls-pinch-to-zoom': <PinchToZoom />,
    'controls-drag-to-rotate': <Rotate3d />,
    'controls-scroll-to-zoom': <ScrollToZoom />,
    '3d-cube': <Cube3d />,
    '3d-cube--filled': <Cube3dFilled />,
    'phone--filled': <Phone />,

    'drag-drop': <DragDrop />,
    'add-person': <AddPerson />,
    'animation-hand': <Hand />,

    'no-border': <NoBorder />,
    'border': <Border />
};